import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Tooltip, useMap } from "react-leaflet";
import L from "leaflet";

const icon = (lead, active) => L.divIcon({
  className: "",
  html: `<div class="pin ${lead.intent} ${active ? "active" : ""}"><span>${(lead.category || "o")[0].toUpperCase()}</span></div>`,
  iconSize: [26, 26],
  iconAnchor: [13, 26],
});

const Fit = ({ leads, active }) => {
  const map = useMap();
  // MapContainer may call map.remove() before this cleanup runs; stop() on a removed map crashes (_leaflet_pos)
  useEffect(() => () => { if (map._mapPane) map.stop(); }, [map]);
  useEffect(() => {
    if (!active) return;
    try {
      map.flyTo([active.lat, active.lng], Math.max(map.getZoom(), 11), { duration: 0.6 });
    } catch (e) { console.warn("map not ready", e); }
  }, [active, map]);
  useEffect(() => {
    if (!leads.length) return;
    try {
      map.fitBounds(L.latLngBounds(leads.map((l) => [l.lat, l.lng])), { padding: [40, 40], maxZoom: 11, animate: false });
    } catch (e) { console.warn("map not ready", e); }
  }, [leads, map]);
  return null;
};

const Resize = ({ visible }) => {
  const map = useMap();
  useEffect(() => {
    if (visible) map.invalidateSize();
  }, [visible, map]);
  return null;
};

export const LeadMap = ({ leads, active, onSelect, visible = true }) => (
  <div className="h-full min-h-[460px] rounded-2xl overflow-hidden border border-slate-200 bg-white" data-testid="lead-map">
    <MapContainer center={[39.5, -98.35]} zoom={4} className="h-full w-full min-h-[460px]" scrollWheelZoom>
      <TileLayer attribution='&copy; OpenStreetMap contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      {leads.map((l) => (
        <Marker key={l.id} position={[l.lat, l.lng]} icon={icon(l, active?.id === l.id)} eventHandlers={{ click: () => onSelect(l) }}>
          <Tooltip direction="top" offset={[0, -24]}>
            <strong>{l.name}</strong><br />{[l.city, l.state].filter(Boolean).join(", ")}
          </Tooltip>
        </Marker>
      ))}
      <Fit leads={leads} active={active} />
      <Resize visible={visible} />
    </MapContainer>
  </div>
);
